import { defineStyle } from '@chakra-ui/react';

import colors from '@/styles/themes/brand/colors';
import FontSizes from '@/styles/themes/brand/fontSizes';
import FontWeights from '@/styles/themes/brand/fontWeights';

const style = defineStyle({
  root: {
    minH: 'calc(100vh - 200px)',
    h: '100%',
    '.news-section-header-container': {
      position: 'relative',
      ':before': {
        zIndex: 1,
        content: '""',
        bottom: 0,
        position: 'absolute',
        width: '100%',
        height: { base: '150px', lg: '250px' },
        background: `linear-gradient(0deg, ${colors.background} 2.19%, rgba(255, 255, 255, 0.675338) 40.95%, rgba(255, 255, 255, 0) 76.89%)`,
      },
      pb: { base: '45%', md: '30%' },
    },
    '.news-section-image': {
      position: 'absolute',
      width: '100%',
      height: '100%',
    },
    '.news-section-heading-wrapper': {
      align: 'start',
      position: 'absolute',
      bottom: 0,
      zIndex: 1,
    },
    '.news-section-heading': {
      fontWeight: { base: FontWeights.normal, xl: FontWeights.light },
      fontSize: {
        base: FontSizes.fourXLarge,
        xl: FontSizes.sixHalfXLarge,
      },
      color: colors.secondaryHover,
    },
    '.news-section-body': {
      direction: 'column',
      alignItems: 'center',
      my: '72px',
    },
    '.news-section-body-inner': {
      direction: 'column',
      w: { base: '95%', md: '70%', lg: '50%' },
      gap: '64px',
    },
    '.news-section-button-wrap': {
      flexWrap: 'wrap-reverse',
    },
    '.news-section-icon-arrowBack': {
      w: '20px',
      h: '20px',
    },
    '.news-section-icon-arrow': {
      path: {
        stroke: 'white',
      },

      w: '24px',
      h: '24px',
    },
    '.news-section-button-prev': {
      w: { base: '100%', sm: 'auto' },
    },
    '.news-section-button-next': {
      w: { base: '100%', sm: 'auto' },
    },
  },
});

export default style;
